<div
  (click)="removeNotification()"
  class="notification"
  [ngClass]="{'notification--error': isError, 'notification--info': isInfo}">
  <div class="notification__icon">
    <app-svg-icon [iconName]="iconName" width="40" height="40"></app-svg-icon>
  </div>

  <div class="notification-text">
    <div class="notification-text__title">
      <ng-container *ngIf="isSuccess">Success</ng-container>
      <ng-container *ngIf="isError">Error</ng-container>
      <ng-container *ngIf="isInfo">Info</ng-container>
    </div>
    <div class="notification-text__description">{{notification.message}}</div>
  </div>
</div>
